// extracted by mini-css-extract-plugin
export var infoItem = "_tn-2";
export var title = "_tn-0";
export var value = "_tn-1";